import { JwtAxios } from '@/packaging';

// 상품 리포트 전용 API 집합
// 백엔드 구현 시 아래 엔드포인트를 맞춰주면 됩니다.
// - Summary: 상단 카드/차트용 집계
// - List: 하단 그리드 데이터
// - Excel: 현재 조회 조건 기반 다운로드
export const productReportApi = {
  async getSummary(body) {
    // body: { tabType, startDate, endDate, marketGroupIds, marketIds, sources }
    const res = await JwtAxios.post('/ProductReport/GetSummary', body);
    return res;
  },
  async getList(body) {
    // body: { tabType, startDate, endDate, marketGroupIds, marketIds, sources, page, pageSize, sort }
    const res = await JwtAxios.post('/ProductReport/GetList', body);
    return res;
  },
  async downloadExcel(body) {
    // body는 getList와 동일, 백엔드는 Content-Disposition 헤더로 파일명 내려주세요.
    const res = await JwtAxios.excelMultiPartPost('/ProductReport/DownloadExcel', body);
    return res;
  }
};

